import { Button, Center, Heading } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <Center bg="#f9bf3b" py={5} mb={10} color="#000">
      <Heading size="xl" px={5} isTruncated>
        MERN MOVIE APP
        <Link to={'/'}>
          <Button
            bg="#000"
            color="#fff"
            ml={4}
            _hover={{
              background: '#ff0000',
              color: '#fff',
            }}
          >
            HOME
          </Button>
        </Link>
        <Link to={'/search/'}>
          <Button
            bg="#000"
            color="#fff"
            ml={4}
            _hover={{
              background: '#ff0000',
              color: '#fff',
            }}
          >
            SEARCH MOVIES
          </Button>
        </Link>
        <Link to={'/favorites/'}>
          <Button
            bg="#000"
            color="#fff"
            ml={4}
            _hover={{
              background: '#ff0000',
              color: '#fff',
            }}
          >
            FAVORITES
          </Button>
        </Link>
        <Link to={'/auth/'}>
          <Button
            bg="#000"
            color="#fff"
            ml={4}
            _hover={{
              background: '#ff0000',
              color: '#fff',
            }}
          >
            AUTHENTICATION
          </Button>
        </Link>
      </Heading>
    </Center>
  );
};

export default Header;
